module.exports = __webpack_public_path__ + "img/diente85.771f6414.png";